import { get } from '../axios/axiosGateway';

export const getPermissions = () => {
  return get(`/permissions`);
};
